import { DEFAULT_LICENSES_MODAL_STATE } from './consts';
import { LicensesModalAction, LicensesModalState } from './types';

export const licensesModalReducer = (state: LicensesModalState, action: LicensesModalAction): LicensesModalState => {
  switch (action.type) {
    case 'setIsViewMode': {
      return {
        ...state,
        isViewMode: action.isViewMode,
      };
    }
    case 'setToSuspendAutorenewal': {
      return {
        ...state,
        toSuspendAutorenewal: [...action.toSuspendAutorenewal],
      };
    }
    case 'setToEnableAutorenewal': {
      return {
        ...state,
        toEnableAutorenewal: [...action.toEnableAutorenewal],
      };
    }
    case 'setLicensesSubscriptionCost': {
      return {
        ...state,
        licensesSubscriptionCost: action.licensesSubscriptionCost,
      };
    }
    case 'resetState': {
      return {
        ...state,
        ...DEFAULT_LICENSES_MODAL_STATE,
      };
    }
    default:
      return state;
  }
};
